module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/t0Td32/tc-custom/9781611523973.jpg?1723403952703",
      "alt": "This image is the cover for the book Colin and Martin's Goodbye Christmas, Colin and Martin"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Colin and Martin's Goodbye Christmas, Colin and Martin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The fourth and final Colin and Martin Christmas story sees the two men leaving Yorkshire to begin new lives in Australia."), _c('br'), _c('br'), _vm._v("Martin Kellam has no qualms about saying goodbye to what remains of his family, while Colin’s parting gift to Martin’s brother is a well-deserved punch in the nose."), _c('br'), _c('br'), _vm._v("Before leaving, the two men have one final Christmas in London with Colin’s parents, who are pulling out all the stops to make it an occasion to remember."), _c('br'), _c('br'), _vm._v("Martin enjoys teasing his husband. He knows Colin can never resist going in search of presents before Christmas Day. As this is their last winter Christmas, Martin boxes up a lump of coal and puts it somewhere where Colin will find it."), _c('br'), _c('br'), _vm._v("The festivities are brought to an abrupt halt when Colin’s mother reveals disturbing news that throws Colin and Martin’s emigration plans into turmoil."), _c('br'), _c('br'), _vm._v("Despite Martin’s much-needed comfort and reassurance, Colin is torn between family obligation and the future he and Martin have longed for. Can Martin show him that he can have both?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Drew Hunt\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0